export default {
  set(key, value, ttl) {
    // `item` is an object which contains the original value as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: new Date().getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  },
  get(key) {
    const stringItem = localStorage.getItem(key)

    // if the item doesn't exist, return null
    if (!stringItem) {
      return null
    }

    const item = JSON.parse(stringItem)

    // compare the expiry time of the item with the current time
    if (new Date().getTime() > item.expiry) {
      // if the item is expired, delete the item from storage and return null
      localStorage.removeItem(key)
      return null
    }

    return item.value
  },
  remove(key) {
    localStorage.removeItem(key)
  }
};



// WEBPACK FOOTER //
// ./src/plugins/cache.js